var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"google-map",class:{ grey: _vm.loading },attrs:{"id":_vm.mapName}},[_vm._t("infoWindow")],2)}
var staticRenderFns = []

export { render, staticRenderFns }